import { render } from "./ExternalRepairs.vue?vue&type=template&id=e2dab8c2"
import script from "./ExternalRepairs.vue?vue&type=script&lang=js"
export * from "./ExternalRepairs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__